import { render, staticRenderFns } from "./emergency_info.vue?vue&type=template&id=7ae1dffa&"
import script from "./emergency_info.vue?vue&type=script&lang=js&"
export * from "./emergency_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports